/** An abort resolves at once. Use `pollDelay` for a wait that must reject. */
export function sleep(ms: number, signal?: AbortSignal): Promise<void> {
  return new Promise((resolve) => {
    if (signal?.aborted === true) {
      resolve();
      return;
    }
    const timeoutId = setTimeout(done, ms);
    signal?.addEventListener('abort', done, { once: true });

    function done(): void {
      clearTimeout(timeoutId);
      signal?.removeEventListener('abort', done);
      resolve();
    }
  });
}
